// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__3zm99","title":"AfterImages45_title__2m-a0","images":"AfterImages45_images__1YVri"};